import { render, staticRenderFns } from "./CursosPainel.vue?vue&type=template&id=1a1ba757&scoped=true&"
import script from "./CursosPainel.vue?vue&type=script&lang=js&"
export * from "./CursosPainel.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=1a1ba757&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ba757",
  null
  
)

export default component.exports